import mitt from 'mitt'
import { defineNuxtPlugin } from '#app/nuxt'

export const emitter = mitt()

export default defineNuxtPlugin((nuxtApp) => {
  const eventbus = {
    $on: emitter.on,
    $off: emitter.off,
    $emit: emitter.emit
  }

  nuxtApp.vueApp.mixin({
    data () {
      return {
        EventBus: eventbus
      }
    }
  })

  return {
    provide: {
      eventbus
    }
  }
})